import { omit, has, pick, isEqual, isEqualWith } from 'lodash'

/**
 * cleanUpTag()
 * Clean up the tag that would be rendable by UI/ANS after fetched
 */
export function cleanUpTag(tag) {
  return omit(tag, ['tagId'])
}

// normalize tag to have the required properties that are applied in ANS but not from Tag API
export function normalizeTag(tag) {
  let clonedTag = cleanUpTag(tag)
  const { name } = clonedTag
  delete clonedTag.name
  if (!has(clonedTag, 'text')) {
    clonedTag = {
      ...clonedTag,
      text: name || clonedTag.slug,
    }
  }

  if (!clonedTag.description) {
    if (name) {
      clonedTag.description = name
    } else {
      delete clonedTag.description
    }
  }
  return clonedTag
}

// Check whether the tags fetched from Tag API is already in story obj
export function isTagUsed(tag1, tag2): boolean {
  const clonedTag1 = normalizeTag(tag1)
  const clonedTag2 = normalizeTag(tag2)
  return isEqualWith(clonedTag1, clonedTag2, (objValue, othValue) => {
    // customizer to compare for only specific properties
    const customizedObj1 = pick(objValue, ['text', 'slug', 'description'])
    const customizedObj2 = pick(othValue, ['text', 'slug', 'description'])
    return isEqual(customizedObj1, customizedObj2)
  })
}
